import { Quote } from "lucide-react";

const STATS = [
  { big: "7", label: "major cities covered" },
  { big: "24–48h", label: "from brief to market" },
  { big: "100%", label: "of candidates vetted" },
  { big: "3-month", label: "replacement guarantee" },
];

const TESTIMONIALS = [
  { quote: "We'd been drowning in unvetted CVs for months. One brief later, we had three people who could actually do the job — hired within the fortnight.", name: "Hospitality group owner", city: "Sydney" },
  { quote: "They sorted my work rights before I'd even landed. Walked off the plane on Tuesday, started work the following Monday.", name: "Relocating candidate", city: "Melbourne" },
  { quote: "The membership pays for itself on the first hire. Having a recruiter who actually knows our business is the difference.", name: "Agency principal", city: "Brisbane" },
];

export const SocialProofBar = () => (
  <section className="bg-white border-b border-[#e3e0d3]" data-testid="social-proof-bar">
    <div className="max-w-7xl mx-auto px-6 py-14">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-testid="proof-stats">
        {STATS.map((s) => (
          <div key={s.label}>
            <p className="font-heading text-3xl sm:text-4xl font-black text-[#0d2f4d] tracking-tight">{s.big}</p>
            <p className="text-sm text-[#51637a] mt-1">{s.label}</p>
          </div>
        ))}
      </div>
      <div className="grid md:grid-cols-3 gap-6 mt-12">
        {TESTIMONIALS.map((t, i) => (
          <figure key={i} className="ditch-card p-7" data-testid={`testimonial-card-${i}`}>
            <Quote size={20} className="text-[#C1CC24]" />
            <blockquote className="text-sm text-[#33475b] leading-relaxed mt-3">“{t.quote}”</blockquote>
            <figcaption className="mt-4 text-xs uppercase tracking-[0.15em] font-medium text-[#51637a]">
              {t.name} · <span className="text-[#7C8514]">{t.city}</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);
